
export class EditPliSettingsModalPayload {
  pliData: EditPliPayload;
  compSearchId: number;
  jurisdictionId: number;
}

export class EditPliPayload {
  pliTypeId: number;
  pli: string;
}
